export default class PointGroup {
  constructor(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;

    this.predictGroups = [];
    this.parameterGroups = [];
    this.id = 0;
  }
}
